export const FILTER_WIDTH_STORAGE_KEY = "FiltersWidth";
export const FILTER_EXPANDED_STORAGE_KEY = "FiltersExpanded";
export const FILTER_SPLIT_SIZES_STORAGE_KEY = "FiltersSplitSizes";
export const FILTER_DEFAULT_MIN_WIDTH = 324;
export const FILTER_COLLAPSED_MIN_WIDTH = 44;
export const DEFAULT_VIEW_NAME = "Default view";
export const DEFAULT_VIEW_ID = "defaultView";
export const DEFAULT_VIEW_STORAGE_KEY = "FiltersDefaultView";
